import { render, staticRenderFns } from "./ProductSoldPage.vue?vue&type=template&id=1cd8dc70&scoped=true"
import script from "./ProductSoldPage.vue?vue&type=script&lang=js"
export * from "./ProductSoldPage.vue?vue&type=script&lang=js"
import style0 from "./ProductSoldPage.vue?vue&type=style&index=0&id=1cd8dc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8dc70",
  null
  
)

export default component.exports